//PrimeReact
import { Tooltip } from "primereact/tooltip"

//Styles
import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css"
import Draggable from "../../Draggable"
import formulaBuilderTypes from "../formulaBuilderTypes"

export default function RenderOperator({ operatorItem, isActive, onActivate }) {
  const tooltipTarget = `tt-${operatorItem.name}`

  const isGroupOperator =
    operatorItem.name === formulaBuilderTypes.operatorNames.groupOperator
  const dragData = {
    type: isGroupOperator
      ? formulaBuilderTypes.draggableTypes.group
      : formulaBuilderTypes.draggableTypes.operator,
    id: operatorItem.name,
    object: operatorItem,
  }

  return (
    <Draggable id={`${operatorItem.name}`} data={dragData}>
      <Tooltip
        target={`.${tooltipTarget}`}
        className={myStyles.functionToolTip}
      />
      <div
        className={`${myStyles.operator} ${
          operatorItem.isPurple ? myStyles.operatorPurple : ""
        } ${isActive ? myStyles.activeOperator : ""} ${tooltipTarget} `}
        data-pr-tooltip={operatorItem.tooltip}
        data-pr-position="bottom"
        onClick={() => !isGroupOperator && onActivate(operatorItem.name)}
      >
        {operatorItem.iconName ? (
          <span className="material-icons">{operatorItem.iconName}</span>
        ) : (
          operatorItem.display
        )}
      </div>
    </Draggable>
  )
}
